module.exports = __webpack_public_path__ + "static/media/icon-pine-tree.7540a1da.png";